<ngb-progressbar [type]="getProgressColor()" textType="white" [value]="completion_level"
  [height]="height" [showValue]="true">
</ngb-progressbar>
